import {createSlice} from "@reduxjs/toolkit";
import {DataGridPageState, DEFAULT_TICKET_FILTER, TicketFilterFormValues} from "@ots-frontend/ots-ui";
import {
  setTicketPageFilter,
  setTicketPageStateOilCell,
  setTicketPageStateOilSort,
  setTicketPageStateOilWidths,
  setTicketPageStateSort
} from "./actions";
import {setTicketPageStateCell, setTicketPageStateWidths} from "../ticket-page/actions";

const savedColWidths = localStorage.getItem("ticketPageWidths3")
const savedOilColWidths = localStorage.getItem("ticketPageOilWidths3")

type State = {
  filter: TicketFilterFormValues
  state: {
    standard: DataGridPageState,
    oil: DataGridPageState
  }
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_TICKET_FILTER,
  state: {
    standard: {
      cell: undefined,
      widths: savedColWidths ? JSON.parse(savedColWidths) : [],
    },
    oil: {
      cell: undefined,
      widths: savedOilColWidths ? JSON.parse(savedOilColWidths) : [],
    }
  },
};

const ticketPageSlice = createSlice({
  name: "ui/ticket-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setTicketPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setTicketPageStateCell,
      (state, {payload}) => {
        state.state.standard.cell = payload
      }
    );
    builder.addCase(
      setTicketPageStateOilCell,
      (state, {payload}) => {
        state.state.oil.cell = payload
      }
    );
    builder.addCase(
      setTicketPageStateWidths,
      (state, {payload}) => {
        state.state.standard.widths = payload
      }
    );
    builder.addCase(
      setTicketPageStateOilWidths,
      (state, {payload}) => {
        state.state.oil.widths = payload
      }
    );
    builder.addCase(
      setTicketPageStateSort,
      (state, {payload}) => {
        state.state.standard.sort = payload
      }
    );
    builder.addCase(
      setTicketPageStateOilSort,
      (state, {payload}) => {
        state.state.oil.sort = payload
      }
    );
  }
});

export const ticketPageReducer = ticketPageSlice.reducer;
